<div class="file-uploader" [class.file-uploader--error]="downloadError">
  <p class="icon-container" [class.icon-container--error]="downloadError">
    @if (!downloadError) {
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85714 1H11.7364C12.0911 1 12.4343 1.12568 12.7051 1.35474L17.4687 5.38394C17.8057 5.66895 18 6.08788 18 6.5292V19.0833C18 20.8739 17.9796 21 16.1429 21H4.85714C3.02045 21 3 20.8739 3 19.0833V2.91667C3 1.12612 3.02045 1 4.85714 1ZM7 13C7 12.4477 7.44772 12 8 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H8C7.44772 14 7 13.5523 7 13ZM8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H11C11.5523 18 12 17.5523 12 17C12 16.4477 11.5523 16 11 16H8Z"
          fill="#FC5A5A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.85714 3H14.7364C15.0911 3 15.4343 3.12568 15.7051 3.35474L20.4687 7.38394C20.8057 7.66895 21 8.08788 21 8.5292V21.0833C21 22.8739 20.9796 23 19.1429 23H6.85714C5.02045 23 5 22.8739 5 21.0833V4.91667C5 3.12612 5.02045 3 6.85714 3ZM7 13C7 12.4477 7.44772 12 8 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H8C7.44772 14 7 13.5523 7 13ZM8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H11C11.5523 18 12 17.5523 12 17C12 16.4477 11.5523 16 11 16H8Z"
          fill="#4B45B2"
        />
      </svg>
    } @else {
      <svg width="24" height="24" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.6996 17.586L17.0341 16.7533C16.7999 16.6361 16.5234 16.6361 16.2892 16.7533L13.3307 18.2325L10.3723 16.7533C10.1381 16.6361 9.8616 16.6361 9.62741 16.7533L6.66894 18.2325L3.71047 16.7533C3.47628 16.6361 3.19972 16.6361 2.96553 16.7533L1.30006 17.586C1.01872 17.7275 0.839844 18.0154 0.839844 18.3308V28.3235C0.839844 28.7838 1.21231 29.1562 1.67253 29.1562H18.3269C18.7873 29.1562 19.1596 28.7837 19.1596 28.3235V18.3308C19.1599 18.0154 18.981 17.7275 18.6996 17.586ZM18.3271 0.84375H7.50181V6.67275C7.50181 7.13306 7.12935 7.50544 6.66913 7.50544H0.840031V14.1672C0.840031 14.4559 0.989655 14.7234 1.23528 14.8755C1.47762 15.0267 1.78662 15.0406 2.04519 14.9121L3.33819 14.2656L6.29666 15.7448C6.53085 15.8618 6.80741 15.8618 7.0416 15.7448L9.99997 14.2657L12.9584 15.7448C13.1926 15.8619 13.4693 15.8618 13.7034 15.7448L16.6618 14.2657L17.9549 14.9122C18.2134 15.0414 18.5208 15.0268 18.7648 14.8756C19.0104 14.7235 19.16 14.456 19.16 14.1673V1.67644C19.1599 1.21622 18.7874 0.84375 18.3271 0.84375ZM5.83635 1.33172L1.32791 5.84006H5.83635V1.33172Z"
          fill="#FC5A5A"
        />
      </svg>
    }
  </p>
  @if ({ size: fileSize$ | async }; as fileInfo) {
    <div class="label">
      <p class="label__text label__text--name" [class.label__text--error]="downloadError">
        {{ fileDisplayName }}
      </p>
      <p class="label__text label__text--desc">
        @if (downloadError) {
          Erreur de chargement du fichier
        }
        @if (!downloadError && fileInfo.size) {
          {{ fileInfo.size | fileSize }}
        }
        @if (!downloadError && !fileInfo.size) {
          Chargement du fichier...
        }
      </p>
    </div>
  }
  <ul class="actions">
    @if (file && !url) {
      <li>
        @if (uploadProgress$ | async; as uploadProgress) {
          <app-file-picker-spinner
            [progress]="uploadProgress"
            [diameter]="22"
            [strokeWidth]="2"
            [ariaLabel]="fileDisplayName + 'chargé à ' + uploadProgress + '%'"
          />
        }
      </li>
    }
    @if (file && url) {
      <li>
        <button
          class="action-button"
          [class.action-button--error]="downloadError"
          [disabled]="!file"
          (click)="downloadUploadedFile()"
          mat-icon-button
          type="button"
          aria-label="Télécharger le fichier"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.0028 12.0215C11.001 11.9965 11 11.9713 11 11.9459V3.98195C11 3.43243 11.447 2.98645 12 2.98645C12.553 2.98645 13 3.43243 13 3.98195V11.9457L15.4 10.154C15.842 9.82252 16.469 9.91311 16.8 10.3531C17.132 10.7931 17.042 11.4173 16.6 11.7468L12.6 14.7333C12.423 14.8657 12.211 14.9324 12 14.9324C11.799 14.9324 11.598 14.8717 11.425 14.7512L7.425 11.9499C6.973 11.6333 6.864 11.0121 7.182 10.5632C7.5 10.1132 8.123 10.0047 8.575 10.3213L11.0028 12.0215ZM6 16.9234V17.9189H18V16.9234C18 16.3759 18.45 15.9279 19 15.9279C19.55 15.9279 20 16.3759 20 16.9234V18.9144C20 19.4619 19.55 19.9099 19 19.9099H5C4.45 19.9099 4 19.4619 4 18.9144V16.9234C4 16.3759 4.45 15.9279 5 15.9279C5.55 15.9279 6 16.3759 6 16.9234Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </li>
    }
    <li>
      <button
        class="action-button"
        [attr.aria-label]="file === null ? 'Annuler le téléversement du fichier' : 'Supprimer le fichier'"
        [class.action-button--error]="downloadError"
        (click)="fileCancelled.emit()"
        mat-icon-button
        type="button"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4142 11.946L17.7072 7.67234C18.0982 7.2831 18.0982 6.65395 17.7072 6.26471C17.3162 5.87547 16.6842 5.87547 16.2933 6.26471L12.0002 10.5384L7.70725 6.26471C7.31625 5.87547 6.68425 5.87547 6.29325 6.26471C5.90225 6.65395 5.90225 7.2831 6.29325 7.67234L10.5862 11.946L6.29325 16.2197C5.90225 16.6089 5.90225 17.2381 6.29325 17.6273C6.48825 17.8214 6.74425 17.919 7.00025 17.919C7.25625 17.919 7.51225 17.8214 7.70725 17.6273L12.0002 13.3536L16.2933 17.6273C16.4882 17.8214 16.7443 17.919 17.0002 17.919C17.2562 17.919 17.5122 17.8214 17.7072 17.6273C18.0982 17.2381 18.0982 16.6089 17.7072 16.2197L13.4142 11.946Z"
            fill="currentColor"
          />
          <mask
            class="action-button__mask"
            id="mask0_1085_1511"
            maskUnits="userSpaceOnUse"
            x="6"
            y="5"
            width="13"
            height="13"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.4142 11.946L17.7072 7.67234C18.0982 7.2831 18.0982 6.65395 17.7072 6.26471C17.3162 5.87547 16.6842 5.87547 16.2933 6.26471L12.0002 10.5384L7.70725 6.26471C7.31625 5.87547 6.68425 5.87547 6.29325 6.26471C5.90225 6.65395 5.90225 7.2831 6.29325 7.67234L10.5862 11.946L6.29325 16.2197C5.90225 16.6089 5.90225 17.2381 6.29325 17.6273C6.48825 17.8214 6.74425 17.919 7.00025 17.919C7.25625 17.919 7.51225 17.8214 7.70725 17.6273L12.0002 13.3536L16.2933 17.6273C16.4882 17.8214 16.7443 17.919 17.0002 17.919C17.2562 17.919 17.5122 17.8214 17.7072 17.6273C18.0982 17.2381 18.0982 16.6089 17.7072 16.2197L13.4142 11.946Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1085_1511)" />
        </svg>
      </button>
    </li>
  </ul>
</div>
